var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.locations.length)?_c('div',{staticClass:"map-wrapper",style:({ paddingBottom: _vm.height + '%' })},[_c('div',{ref:"map",staticClass:"product-location-map",attrs:{"role":"region","aria-label":_vm.hotel ? 'Hotel and destination map' : 'Parking lot and destination map'}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }